import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../helpers/Utility';

const initialState = {
  messageData: [],
  docDSKL: '',
  docSP: ''
};

const getNotificationUser = (state, action) => {
  return updateObject(state, { messageData: action.message });
};

const setDocDSKL = (state, action) => {
  return updateObject(state, { docDSKL: action.doc });
};

const setDocSP = (state, action) => {
  return updateObject(state, { docSP: action.doc });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NOTIFICATION_USER:
      return getNotificationUser(state, action);
    case actionTypes.SET_DOC_DSKL:
      return setDocDSKL(state, action);
    case actionTypes.SET_DOC_SP:
      return setDocSP(state, action);
    default:
      return state;
  }
};

export default reducer;
